import { FC } from 'react'
import styled from 'styled-components'
import { Close } from 'svgIcons'

interface IFActivityFilterTopProps {
  onClose: () => void
  className?: string
}

const ActivityFilterTop: FC<IFActivityFilterTopProps> = ({
  onClose,
  className,
}) => {
  return (
    <StyledWrapper className={className}>
      <div onClick={onClose} className="close-button">
        <Close />
      </div>
      <div>상세 검색</div>
    </StyledWrapper>
  )
}

export default ActivityFilterTop

const StyledWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 50px;
  font-size: 16px;
  font-weight: bold;

  .close-button {
    position: absolute;
    top: 14px;
    left: 20px;
    width: 16px;
    height: 16px;
  }
`
